import { Box, styled } from "@mui/material";

export const ActionsContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "showCreateButton",
})<{ showCreateButton?: boolean }>(({ theme, showCreateButton }) => ({
  position: "absolute",
  // Anchor from top of icon buttons row so it doesn't shift when create button is added
  top: "20%",
  left: "50%",
  transform: "translateX(-50%)",
  zIndex: 10,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: theme.spacing(3),
  paddingBottom: showCreateButton ? 0 : theme.spacing(3),
  borderRadius: theme.spacing(2),
  backgroundColor: "rgba(255, 255, 255, 0.7)",
  backdropFilter: "blur(10px)",
  WebkitBackdropFilter: "blur(10px)",
  transition: "opacity 0.2s ease, transform 0.2s ease",
  overflow: "hidden",
}));
